import React, { useState } from 'react';
import { Phone, Menu, X } from 'lucide-react';
import { businessInfo } from '../data/mock';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const navLinks = [
    { name: 'Services', href: '/services' },
    { name: 'Products', href: '/products' },
    { name: 'About', href: '/about' },
    { name: 'Contact', href: '/contact' },
  ];

  return (
    <header className="fixed top-0 w-full z-50 backdrop-blur-xl bg-[#050505]/70 border-b border-white/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <a href="/" className="flex items-center">
            <div className="flex flex-col">
              <span className="text-lg font-bold text-white">Professional Garage Door Service</span>
              <span className="text-xs text-neutral-400 font-semibold">Locally Owned & Operated</span>
            </div>
          </a>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <a
                key={link.name}
                href={link.href}
                className="text-sm font-medium text-neutral-300 hover:text-[#D4AF37] transition-colors"
              >
                {link.name}
              </a>
            ))}
          </nav>

          {/* Call Button */}
          <a
            href={`tel:${businessInfo.phone}`}
            data-testid="nav-call-button"
            className="hidden md:flex items-center gap-2 px-6 py-3 bg-[#D4AF37] hover:bg-[#F0C84A] text-[#050505] font-bold rounded-xl transition-all duration-300 hover:scale-105"
          >
            <Phone size={20} />
            <span>{businessInfo.phone}</span>
          </a>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden p-2 text-white"
          >
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden py-6 border-t border-white/10">
            <nav className="flex flex-col gap-4">
              {navLinks.map((link) => (
                <a
                  key={link.name}
                  href={link.href}
                  className="text-base font-medium text-neutral-300 hover:text-[#D4AF37] transition-colors py-2"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  {link.name}
                </a>
              ))}
              <a
                href={`tel:${businessInfo.phone}`}
                className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-[#D4AF37] text-[#050505] font-bold rounded-xl mt-4"
                onClick={() => setMobileMenuOpen(false)}
              >
                <Phone size={20} />
                <span>{businessInfo.phone}</span>
              </a>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
